// extracted by mini-css-extract-plugin
module.exports = {"formGroupInput":"FormGroupInput_formGroupInput__2AXTs","errorSymbol":"FormGroupInput_errorSymbol__2WgC4","errorMessage":"FormGroupInput_errorMessage__3878f"};